export type QuoteInterest =
  | ''
  | 'school_wide_license'
  | 'single_event_license'
  | 'field_trip_license'
  | 'staff_team_building'
  | 'general_question'
  | 'other';

const quoteInterestSelectOps: Array<{ value: QuoteInterest; label: string }> = [
  {
    value: 'school_wide_license',
    label: "I'm interested in purchasing a school/district license",
  },
  {
    value: 'single_event_license',
    label: "I'm interested in purchasing a single event license",
  },
  {
    value: 'field_trip_license',
    label: "I'd like to use Goosechase on a class field trip",
  },
  {
    value: 'staff_team_building',
    label: "I'd like to use Goosechase for a faculty/staff team building event",
  },
  {
    value: 'general_question',
    label: 'I have a question about Goosechase',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export function getK12InterestSelectOps() {
  return quoteInterestSelectOps;
}

export function getHigherEdSelectOps() {
  return quoteInterestSelectOps
    .filter((op) => op.value !== 'field_trip_license')
    .map((op) => {
      if (op.value === 'school_wide_license') {
        return {
          ...op,
          label: "I'm interested in purchasing an institution license",
        };
      }

      return op;
    });
}
